import React from 'react';
import BundleLoader from '../../containers/BundleLoader';
import Loading from '../../components/Loading/Loading';

const AsyncWrapperForWorkout = (props) => (
  <BundleLoader load={() => import(/* webpackMode: "lazy", webpackChunkName: "WorkoutPage" */'./Workout')}>
    {(Comp) => (Comp ? <Comp {...props} /> : <Loading />)}
  </BundleLoader>
);
export default AsyncWrapperForWorkout;
